export default __webpack_public_path__ + "static/hero-about-a0d0c692ea9cf07c6dc3ff3fcf8b74aa.jpg";